import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { NewContainerProps } from "../../../../interfaces/containers";
import Variant from "../../../../pages/Sell/New/variant";
import { updateVariants, postNewVariantFile, deleteNewVariantFile } from "../../../../actions/salePost";
import { setColor as setColorReducer } from "../../../../actions/colors";

function mapStateToProps(state: NewContainerProps) {
    return{
        colors: state.colors.colors,
        variants: state.salePost.new.variants
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        updateVariants,
        setColorReducer,
        postNewVariantFile,
        deleteNewVariantFile
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Variant);